import { render, staticRenderFns } from "./BopModelsSiteConfiguration.vue?vue&type=template&id=4596ec84&scoped=true"
import script from "./BopModelsSiteConfiguration.vue?vue&type=script&lang=ts"
export * from "./BopModelsSiteConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596ec84",
  null
  
)

export default component.exports